/* global google */

if (!Array.isArray(window.markersArray)) {
  window.markersArray = [];
}

const HOVER_MARKER_SCALE = 1.25;

function findMarkerByStoreId(storeId) {
  if (!Array.isArray(window.markersArray)) {
    return null;
  }

  return (
    window.markersArray.find(
      (marker) => String(marker.storeId) === String(storeId),
    ) || null
  );
}

function getHoverMarkerUrl($item) {
  const explicitHoverMarker = $item.attr('data-hover-marker');
  if (explicitHoverMarker) {
    return explicitHoverMarker;
  }

  const markerSrc = $item.find('.dealer-card__marker').attr('src');
  if (!markerSrc) {
    return null;
  }

  const basePath = markerSrc.replace(/\/[^/]+\.svg(?:\?.*)?$/, '/');

  // Default hover marker. Per item override is possible with data-hover-marker.
  return `${basePath}topdealer.png`;
}

function buildHoverIcon(marker, hoverMarkerUrl) {
  const originalIcon =
    typeof marker.getIcon === 'function' ? marker.getIcon() : null;

  if (
    originalIcon &&
    typeof originalIcon === 'object' &&
    !Array.isArray(originalIcon) &&
    originalIcon.scaledSize &&
    originalIcon.anchor &&
    typeof google !== 'undefined' &&
    google.maps
  ) {
    const hoverWidth = Math.round(
      originalIcon.scaledSize.width * HOVER_MARKER_SCALE,
    );
    const hoverHeight = Math.round(
      originalIcon.scaledSize.height * HOVER_MARKER_SCALE,
    );

    return {
      ...originalIcon,
      url: hoverMarkerUrl,
      scaledSize: new google.maps.Size(hoverWidth, hoverHeight),
      anchor: new google.maps.Point(
        Math.round(originalIcon.anchor.x * HOVER_MARKER_SCALE),
        Math.round(originalIcon.anchor.y * HOVER_MARKER_SCALE),
      ),
    };
  }

  if (
    originalIcon &&
    typeof originalIcon === 'object' &&
    !Array.isArray(originalIcon)
  ) {
    return {
      ...originalIcon,
      url: hoverMarkerUrl,
    };
  }

  return hoverMarkerUrl;
}

$(function () {
  if (!$('#wpsl-gmap').length) {
    return;
  }

  $('#wpsl-stores').on('mouseenter', 'li', function () {
    const marker = findMarkerByStoreId($(this).data('store-id'));
    const hoverMarkerUrl = getHoverMarkerUrl($(this));

    if (!marker || !hoverMarkerUrl || typeof marker.setIcon !== 'function') {
      return;
    }

    if (typeof marker.__originalIcon === 'undefined') {
      marker.__originalIcon =
        typeof marker.getIcon === 'function' ? marker.getIcon() : null;
    }

    marker.setIcon(buildHoverIcon(marker, hoverMarkerUrl));

    if (
      typeof marker.setAnimation === 'function' &&
      google?.maps?.Animation?.BOUNCE
    ) {
      marker.setAnimation(google.maps.Animation.BOUNCE);
    }
  });

  $('#wpsl-stores').on('mouseleave', 'li', function () {
    const marker = findMarkerByStoreId($(this).data('store-id'));

    if (!marker || typeof marker.setIcon !== 'function') {
      return;
    }

    if (typeof marker.__originalIcon !== 'undefined') {
      marker.setIcon(marker.__originalIcon);
    }

    if (typeof marker.setAnimation === 'function') {
      marker.setAnimation(null);
    }
  });
});
